import React, { Component } from 'react';

let notifications = {};
let isVisible = true;

class Notifications extends Component {

  changeHandler = () => {
    if (document.visibilityState === "visible") {
      isVisible = true;
    } else {
      isVisible = false;
    }
  };

  componentDidMount() {
    let ua = navigator.userAgent;
    /* MSIE used to detect old browsers and Trident used to newer ones*/
    let is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
    
    // if(!is_ie) {
    if("Notification" in window){
      window.Notification.requestPermission();
    }

    document.addEventListener("visibilitychange", this.changeHandler);
  }

  componentWillReceiveProps(nextProps) {
    let ua = navigator.userAgent;
    let is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
    
    // if (!is_ie &&
    if("Notification" in window &&
       (nextProps.callData.id !== this.props.callData.id || nextProps.callData.callStartTime !== this.props.callData.callStartTime)
    ) {
      if (isVisible) {
        // console.log("cancelled on visiblity, webagent");
      } else {
        // console.log("notification triggered, webagent");
        this.createNotification(nextProps.callData);
      }
    }
    // if (!is_ie && 
    if("Notification" in window && 
       (nextProps.callTerminate && nextProps.callTerminateTime !== this.props.callTerminateTime && notifications[nextProps.callTerminate])
    ) {
      notifications[nextProps.callTerminate].close();
      delete notifications[nextProps.callTerminate];
    }
  }

  componentWillUnmount() {
    document.removeEventListener("visibilitychange", this.changeHandler);
  }

  createNotification(callData) {
    if (callData.type === "outgoing") {

      notifications[callData.id] = new Notification("Outgoing Call",
      {
        icon: 'http://www.iconhot.com/icon/png/default-icon/64/arrow-up-11.png',
        body: `${callData.application_name ? callData.application_name : ''}\n${callData.service_name ? callData.service_name : ''}\n${callData.to}`,
        requireInteraction: true
      });

    }
    else {

      // Control de notificacion con datos vacios.
      if (Object.keys(callData).length > 0)
      {
        notifications[callData.id] = new Notification("Incoming Call",
          {
            icon: 'http://www.iconhot.com/icon/png/default-icon/64/arrow-down-12.png',
            body: `${callData.application_name ? callData.application_name : ''}\n${callData.service_name ? callData.service_name : ''}\n${callData.from}`,
            requireInteraction: true
          }
        );
        notifications[callData.id].onclick = function(event) {
          event.preventDefault();
          window.focus()
        }
      }
      /*
      else
      {
        console.log("WA notification INVALID!!!: ", callData.id);
      }
      */
    }
  }

  render() {
    return null;
  }
}

export default Notifications;



// WEBPACK FOOTER //
// ./src/agent/Notifications.js